import React from 'react'

export default ({title, text, link, linkText}) => (
  <div className='alert alert-warning' role='alert' style={{padding: '20px', marginBottom: '-8px'}}>
    <div className='row'>
      <div className='col-xs-1 hidden-xs' style={{marginTop: '4px'}}><i className='pull-right fa fa-exclamation-circle fa-2x red-color' /></div>
      <span className='col-lg-4 col-sm-3 bold hidden-xs' style={{marginTop: '8px', fontSize: '18px', paddingRight: 0}}>{title}</span>
      <span className='col-lg-5 col-sm-6 small hidden-xs' style={{paddingRight: 0}}>{text}</span>
      <div className='col-xs-2 hidden-xs' style={{paddingRight: 0}}><a className='pull-right bold text-nowrap ' style={{marginTop: '16px', paddingRight: '2px'}} href={link}>{linkText}</a></div>

      <span className='col-xs-12 bold visible-xs text-center' style={{marginTop: '8px', fontSize: '18px', paddingRight: 0}}><i style={{paddingRight: '8px'}} className='fa fa-exclamation-circle fa-2x red-color' />{title}</span>
      <span className='col-xs-12 text-center small visible-xs' style={{paddingRight: 0}}>{text}</span>
      <div className='col-xs-12 text-center visible-xs pull-down-xs-1' style={{paddingRight: 0}}><a className='bold text-nowrap ' style={{marginTop: '8px'}} href={link}>{linkText}</a></div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/dashboard/alert.jsx